import { Injectable } from "@angular/core";
import { environment } from "../../environments/environment";

@Injectable({
  providedIn: "root",
})
export class LogService {
  isProd() {
    return environment.production;
  }

  log(message: string, obj: any = {}) {
    const logEntry = this.createLogStatement("debug", message);
    if (this.isProd()) {
      console.log(logEntry);
      return logEntry;
    }

    console.log(logEntry, obj);
    return logEntry;
  }

  createLogStatement(level, message) {
    const SEPARATOR = " ";
    const date = this.getCurrentDate();
    return "[" + level + "]" + SEPARATOR + date + SEPARATOR + message;
  }

  getCurrentDate() {
    const now = new Date();
    return "[" + now.toLocaleString() + "]";
  }
}
